export const courtsData = [
  {
    id: 1,
    name: "Court Central",
    type: "central",
    description: "Court principal — Compétitions et matchs officiels. Surface aux normes internationales ITF.",
    icon: "ri-vip-crown-line",
    features: ["Surface ITF", "Gradins", "Éclairage nocturne", "Tableau d'affichage"]
  },
  {
    id: 2,
    name: "Court 1",
    type: "standard",
    description: "Court standard — Entraînements avancés et matchs amicaux de haut niveau.",
    icon: "ri-building-line",
    features: ["Surface rénovée", "Éclairage LED", "Filets professionnels"]
  },
  {
    id: 3,
    name: "Court 2",
    type: "standard",
    description: "Court standard — Idéal pour les sessions d'entraînement et les cours particuliers.",
    icon: "ri-building-line",
    features: ["Surface rénovée", "Éclairage LED", "Zone d'échauffement"]
  },
  {
    id: 4,
    name: "Court 3",
    type: "standard",
    description: "Court standard — Parfait pour les tournois interclubs et les événements.",
    icon: "ri-building-line",
    features: ["Surface rénovée", "Éclairage LED", "Accès vestiaires"]
  },
  {
    id: 5,
    name: "Training Court 4A",
    type: "training",
    description: "Court d'entraînement — Dédié aux séances collectives et au perfectionnement technique.",
    icon: "ri-run-line",
    features: ["Surface training", "Filets mobiles", "Zone multi-exercices"]
  },
  {
    id: 6,
    name: "Training Court 4B",
    type: "training",
    description: "Court d'entraînement — Espace polyvalent pour débutants et stages intensifs.",
    icon: "ri-run-line",
    features: ["Surface training", "Murs de pratique", "Équipements pédagogiques"]
  }
];

export const keyNumbersData = [
  { value: 6, suffix: "", label: "Courts disponibles", icon: "ri-flag-line" },
  { value: 14, suffix: "h", label: "Ouvert 7j/7 — 8h à 22h", icon: "ri-time-line" },
  { value: 2, suffix: "", label: "Tournois ITF J30 organisés", icon: "ri-trophy-line" },
  { value: 8, suffix: "+", label: "Coachs certifiés", icon: "ri-user-star-line" },
  { value: 60, suffix: "+", label: "Jeunes au Kid Summer Camp", icon: "ri-heart-pulse-line" }
];

export const visionPointsData = [
  "Revalorisation complète du club — infrastructure et positionnement",
  "Formation de coaches certifiés niveau international",
  "Construction et rénovation de courts aux normes ITF",
  "Extension Padel — sport en pleine expansion en Afrique",
  "Rayonnement international — tournois et partenariats"
];

export const heroBadgesData = [
  "Tournois ITF",
  "6 Courts",
  "Certifié International"
];